/** 画面に出す文字をエスケープする。`innerHTML` に渡す値は必ずこれを通す。 */
export const escapeHtml = (s: unknown): string =>
  String(s).replace(
    /[&<>"']/g,
    (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c] ?? c,
  );

/** 検索用の正規化。全角/半角、大文字/小文字、空白・ハイフン・下線の違いを無視する。 */
export const normalizeText = (t: string | null | undefined): string =>
  (t ?? '')
    .normalize('NFKC')
    .toLowerCase()
    .replace(/[\s\-‐−–—_]/g, '');

/** 整数に丸めて、けた区切りをつける。数でなければ「—」。 */
export const formatInt = (v: number): string =>
  Number.isFinite(v) ? Math.round(v).toLocaleString('ja-JP') : '—';

/** 小数 1 けたに丸めて、けた区切りをつける。数でなければ「—」。 */
export const formatFixed1 = (v: number): string =>
  Number.isFinite(v)
    ? (Math.round(v * 10) / 10).toLocaleString('ja-JP', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      })
    : '—';

/**
 * style 属性や SVG の fill に入れる色。`#rrggbb` 以外は灰色にする。
 * HTML のエスケープでは `;` や `url(` による CSS の注入を防げないため、形で絞る。
 */
export const safeColor = (c: string): string => (/^#[0-9a-f]{6}$/i.test(c) ? c : '#888888');
